import { handleVersionMismatch } from 'actions/versionSync';
import { VersionMismatch } from 'services/BaseService';
import {
  SELECT_STORE_FAILURE,
  SELECT_STORE_REQUESTED,
  SELECT_STORE_SUCCESS,
} from '../../actiontypes/exchange';

import ExchangeService from 'services/ExchangeService';

const service = new ExchangeService();


/** ----------------------------------------------------------------------------
 * SELECT STORE
 -----------------------------------------------------------------------------*/
export default function selectStore(shopId = 0) {
  return async (dispatch, getState) => {
    // Have we cached this store?
    const { exchange: { shops } } = getState();

    // If we have data in the cache, use it
    if (shops[shopId].items) {
      return dispatch(selectStoreSuccess(shops[shopId].items, shopId));
    }

    // If not, then fetch the store data
    dispatch(selectStoreRequested(shopId));

    try {
      const { data } = await service.fetchAvailableItems(shopId);
      dispatch(selectStoreSuccess(data, shopId));
    } catch (e) {
      if (e instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(e));
      }
      dispatch(selectStoreFailure(e));
    }
  };
}

const selectStoreRequested = payload => ({ payload, type: SELECT_STORE_REQUESTED });

const selectStoreSuccess = (items, id) => ({
  payload: { id, items },
  type: SELECT_STORE_SUCCESS,
});

const selectStoreFailure = error => ({
  type: SELECT_STORE_FAILURE,
  error: true,
  status: error.response && error.response.status,
});